import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../layout/Footer";
import Navbar from "../../layout/Navbar";

const TermsOfService = () => {
    return (
        <>
        <Navbar />
            <div className="terms-of-service-page">
            <div className="container py-5">
                <div className="row justify-content-center mt-5">
                    <div className="col-lg-10 col-xl-8">
                        
                        {/* Header */}
                        <div className="text-center mb-5">
                            <div className="mb-4">
                                <div className="bg-primary bg-opacity-10 rounded-circle p-4 d-inline-block">
                                    <i className="bi bi-file-text-fill text-primary display-4"></i>
                                </div>
                            </div>
                            <h1 className="display-5 fw-bold mb-3">Terms of Service</h1>
                            <p className="lead text-muted mb-4">
                                Please read these terms carefully before using our services
                            </p>
                            <p className="text-muted">
                                Last updated: {new Date().toLocaleDateString('en-US', { 
                                    year: 'numeric', 
                                    month: 'long', 
                                    day: 'numeric' 
                                })}
                            </p>
                            <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                                <Link to="/" className="btn btn-outline-primary">
                                    <i className="bi bi-house me-2"></i>Back to Home
                                </Link>
                                <Link to="/privacy" className="btn btn-primary">
                                    <i className="bi bi-shield-check me-2"></i>Privacy Policy
                                </Link>
                            </div>
                        </div>

                        {/* Important Notice */}
                        <div className="alert alert-warning mb-5">
                            <div className="d-flex">
                                <div className="me-3">
                                    <i className="bi bi-exclamation-triangle-fill fs-2"></i>
                                </div>
                                <div>
                                    <h5 className="alert-heading">Important Notice</h5>
                                    <p className="mb-0">
                                        By accessing or using <strong>PQ Hub</strong>, you agree to be bound by these Terms of Service. 
                                        If you disagree with any part of these terms, you may not access our services.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Quick Navigation */}
                        <div className="card shadow-sm mb-5">
                            <div className="card-body">
                                <h3 className="h5 fw-bold mb-3">
                                    <i className="bi bi-list-check me-2"></i>
                                    Quick Navigation
                                </h3>
                                <div className="row g-3">
                                    {[
                                        { section: '1', title: 'Acceptance of Terms', icon: 'check-circle' },
                                        { section: '2', title: 'Account Registration', icon: 'person-badge' },
                                        { section: '3', title: 'User Responsibilities', icon: 'person-check' },
                                        { section: '4', title: 'Intellectual Property', icon: 'lightbulb' },
                                        { section: '5', title: 'Content Usage', icon: 'file-earmark-text' },
                                        { section: '6', title: 'Prohibited Activities', icon: 'slash-circle' },
                                        { section: '7', title: 'Termination', icon: 'power' },
                                        { section: '8', title: 'Limitation of Liability', icon: 'shield-exclamation' },
                                        { section: '9', title: 'Changes to Terms', icon: 'arrow-clockwise' },
                                        { section: '10', title: 'Contact Information', icon: 'envelope' },
                                    ].map((item) => (
                                        <div key={item.section} className="col-6 col-md-4 col-lg-3">
                                            <a 
                                                href={`#section-${item.section}`}
                                                className="text-decoration-none"
                                            >
                                                <div className="card border h-100 text-center hover-shadow">
                                                    <div className="card-body py-3">
                                                        <div className="mb-2">
                                                            <span className="badge bg-primary rounded-circle p-2">
                                                                {item.section}
                                                            </span>
                                                        </div>
                                                        <h6 className="card-title mb-0 small fw-semibold">{item.title}</h6>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Section 1: Acceptance of Terms */}
                        <div className="card shadow-sm border-0 mb-4" id="section-1">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">1</span>
                                    <h2 className="h4 fw-bold mb-0">Acceptance of Terms</h2>
                                </div>
                                <div className="ps-5">
                                    <p>
                                        These Terms of Service ("Terms") govern your access to and use of the PQ Hub website, 
                                        mobile application, and services (collectively, the "Service") provided by Pegcodes 
                                        Technologies ("we," "us," or "our").
                                    </p>
                                    <p>
                                        By accessing or using the Service, you agree to be bound by these Terms. If you are 
                                        accessing or using the Service on behalf of a company or other legal entity, you 
                                        represent that you have the authority to bind such entity to these Terms.
                                    </p>
                                    <div className="alert alert-light mt-3">
                                        <p className="mb-0 small">
                                            <i className="bi bi-info-circle me-2"></i>
                                            These Terms constitute a legally binding agreement between you and PQ Hub.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 2: Account Registration */}
                        <div className="card shadow-sm border-0 mb-4" id="section-2">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">2</span>
                                    <h2 className="h4 fw-bold mb-0">Account Registration</h2>
                                </div>
                                <div className="ps-5">
                                    <p>To access certain features of the Service, you may be required to create an account.</p>
                                    
                                    <div className="row mt-3">
                                        <div className="col-md-6 mb-3">
                                            <div className="card border h-100">
                                                <div className="card-header bg-light">
                                                    <strong>Account Requirements</strong>
                                                </div>
                                                <div className="card-body">
                                                    <ul className="mb-0">
                                                        <li>Provide accurate information</li>
                                                        <li>Maintain account security</li>
                                                        <li>Be at least 13 years old</li>
                                                        <li>One account per person</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div className="card border h-100">
                                                <div className="card-header bg-light">
                                                    <strong>Account Security</strong>
                                                </div>
                                                <div className="card-body">
                                                    <ul className="mb-0">
                                                        <li>Keep password confidential</li>
                                                        <li>Notify us of unauthorized access</li>
                                                        <li>You are responsible for all account activity</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <p className="mt-3">
                                        We reserve the right to suspend or terminate accounts that violate these Terms or 
                                        engage in suspicious activities.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Section 3: User Responsibilities */}
                        <div className="card shadow-sm border-0 mb-4" id="section-3">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">3</span>
                                    <h2 className="h4 fw-bold mb-0">User Responsibilities</h2>
                                </div>
                                <div className="ps-5">
                                    <p>As a user of PQ Hub, you agree to:</p>
                                    
                                    <div className="table-responsive mt-3">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th width="40%">Responsibility</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><strong>Compliance with Laws</strong></td>
                                                    <td>Use the Service in accordance with all applicable laws and regulations</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Respectful Conduct</strong></td>
                                                    <td>Interact with other users in a respectful and professional manner</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Content Accuracy</strong></td>
                                                    <td>Ensure any content you submit is accurate and not misleading</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Security</strong></td>
                                                    <td>Protect your login credentials and report any security breaches</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Updates</strong></td>
                                                    <td>Keep your account information current and accurate</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 4: Intellectual Property */}
                        <div className="card shadow-sm border-0 mb-4" id="section-4">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">4</span>
                                    <h2 className="h4 fw-bold mb-0">Intellectual Property</h2>
                                </div>
                                <div className="ps-5">
                                    <div className="row align-items-center mb-4">
                                        <div className="col-md-8">
                                            <p>
                                                All intellectual property rights in the Service, including but not limited to 
                                                copyrights, trademarks, patents, and trade secrets, are owned by or licensed to PQ Hub.
                                            </p>
                                        </div>
                                        <div className="col-md-4 text-center">
                                            <div className="bg-light rounded p-3">
                                                <i className="bi bi-c-circle display-4 text-primary"></i>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row mt-4">
                                        <div className="col-md-6">
                                            <div className="card border h-100">
                                                <div className="card-header bg-success text-white">
                                                    <strong>What You Can Do</strong>
                                                </div>
                                                <div className="card-body">
                                                    <ul>
                                                        <li>Use the Service for personal, non-commercial purposes</li>
                                                        <li>Access and view content as intended</li>
                                                        <li>Share links to our content</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card border h-100">
                                                <div className="card-header bg-danger text-white">
                                                    <strong>What You Cannot Do</strong>
                                                </div>
                                                <div className="card-body">
                                                    <ul>
                                                        <li>Copy, modify, or distribute our content without permission</li>
                                                        <li>Reverse engineer or decompile the Service</li>
                                                        <li>Use our trademarks without authorization</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 5: Content Usage */}
                        <div className="card shadow-sm border-0 mb-4" id="section-5">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">5</span>
                                    <h2 className="h4 fw-bold mb-0">Content Usage</h2>
                                </div>
                                <div className="ps-5">
                                    <p>
                                        PQ Hub provides educational content including past questions and study materials. 
                                        The usage of this content is subject to the following terms:
                                    </p>
                                    
                                    <div className="accordion mt-4" id="contentUsageAccordion">
                                        <div className="accordion-item">
                                            <h3 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                                    Educational Use
                                                </button>
                                            </h3>
                                            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#contentUsageAccordion">
                                                <div className="accordion-body">
                                                    Content is provided for personal educational purposes only. Commercial use 
                                                    or redistribution is strictly prohibited.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                                    Accuracy Disclaimer
                                                </button>
                                            </h3>
                                            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#contentUsageAccordion">
                                                <div className="accordion-body">
                                                    While we strive for accuracy, we do not guarantee that all content is 
                                                    error-free or up-to-date. Users should verify critical information.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item">
                                            <h3 className="accordion-header">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                                                    User Contributions
                                                </button>
                                            </h3>
                                            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#contentUsageAccordion">
                                                <div className="accordion-body">
                                                    By submitting content to PQ Hub, you grant us a license to use, display, 
                                                    and distribute that content in connection with the Service.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 6: Prohibited Activities */}
                        <div className="card shadow-sm border-0 mb-4" id="section-6">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">6</span>
                                    <h2 className="h4 fw-bold mb-0">Prohibited Activities</h2>
                                </div>
                                <div className="ps-5">
                                    <p>You agree not to engage in any of the following prohibited activities:</p>
                                    
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <div className="list-group mb-3">
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Violating any laws or regulations
                                                </div>
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Impersonating others
                                                </div>
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Harassing or threatening others
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="list-group mb-3">
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Hacking or attempting to breach security
                                                </div>
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Distributing malware or viruses
                                                </div>
                                                <div className="list-group-item list-group-item-danger">
                                                    <i className="bi bi-x-circle-fill me-2"></i>
                                                    Spamming or sending unsolicited messages
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="alert alert-danger mt-3">
                                        <h5 className="alert-heading">
                                            <i className="bi bi-exclamation-octagon me-2"></i>
                                            Zero Tolerance Policy
                                        </h5>
                                        <p className="mb-0">
                                            We have a zero-tolerance policy for abusive behavior, cheating, or any form 
                                            of academic dishonesty. Violations may result in immediate account termination.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 7: Termination */}
                        <div className="card shadow-sm border-0 mb-4" id="section-7">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">7</span>
                                    <h2 className="h4 fw-bold mb-0">Termination</h2>
                                </div>
                                <div className="ps-5">
                                    <div className="row">
                                        <div className="col-md-6 mb-4">
                                            <div className="card border h-100">
                                                <div className="card-header bg-info text-white">
                                                    <strong>User Termination Rights</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p>You may stop using our Service at any time by:</p>
                                                    <ul>
                                                        <li>Closing your account through account settings</li>
                                                        <li>Ceasing to use the Service</li>
                                                        <li>Requesting account deletion via email</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <div className="card border h-100">
                                                <div className="card-header bg-warning text-white">
                                                    <strong>Our Termination Rights</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p>We may suspend or terminate your access if:</p>
                                                    <ul>
                                                        <li>You violate these Terms</li>
                                                        <li>Required by law</li>
                                                        <li>For security reasons</li>
                                                        <li>For extended inactivity</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <p>
                                        Upon termination, your right to use the Service will immediately cease. Some provisions 
                                        of these Terms will survive termination, including intellectual property rights, 
                                        warranty disclaimers, and limitation of liability.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Section 8: Limitation of Liability */}
                        <div className="card shadow-sm border-0 mb-4" id="section-8">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">8</span>
                                    <h2 className="h4 fw-bold mb-0">Limitation of Liability</h2>
                                </div>
                                <div className="ps-5">
                                    <div className="alert alert-secondary">
                                        <h5 className="alert-heading">Important Disclaimer</h5>
                                        <p>
                                            To the maximum extent permitted by law, PQ Hub and its affiliates shall not be liable 
                                            for any indirect, incidental, special, consequential, or punitive damages, including 
                                            but not limited to loss of profits, data, use, goodwill, or other intangible losses.
                                        </p>
                                    </div>
                                    
                                    <div className="mt-4">
                                        <h5 className="fw-semibold">Specific Limitations:</h5>
                                        <div className="row g-3 mt-2">
                                            <div className="col-md-6">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <h6 className="card-title">
                                                            <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                                                            Service Availability
                                                        </h6>
                                                        <p className="card-text small mb-0">
                                                            We do not guarantee uninterrupted, secure, or error-free service
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <h6 className="card-title">
                                                            <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                                                            Content Accuracy
                                                        </h6>
                                                        <p className="card-text small mb-0">
                                                            We are not responsible for errors or omissions in educational content
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <h6 className="card-title">
                                                            <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                                                            Third-Party Content
                                                        </h6>
                                                        <p className="card-text small mb-0">
                                                            We are not responsible for third-party websites or services linked from PQ Hub
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <h6 className="card-title">
                                                            <i className="bi bi-exclamation-triangle text-warning me-2"></i>
                                                            User Decisions
                                                        </h6>
                                                        <p className="card-text small mb-0">
                                                            Users are responsible for their academic decisions and results
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 9: Changes to Terms */}
                        <div className="card shadow-sm border-0 mb-4" id="section-9">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">9</span>
                                    <h2 className="h4 fw-bold mb-0">Changes to Terms</h2>
                                </div>
                                <div className="ps-5">
                                    <div className="d-flex align-items-start">
                                        <div className="bg-primary bg-opacity-10 rounded p-3 me-4">
                                            <i className="bi bi-arrow-clockwise text-primary fs-2"></i>
                                        </div>
                                        <div>
                                            <p>
                                                We reserve the right to modify or replace these Terms at any time. If a revision 
                                                is material, we will provide at least 30 days' notice prior to any new terms 
                                                taking effect.
                                            </p>
                                            <p>
                                                By continuing to access or use our Service after those revisions become effective, 
                                                you agree to be bound by the revised terms.
                                            </p>
                                            <div className="alert alert-info mt-3">
                                                <h6 className="alert-heading">How We Notify You of Changes</h6>
                                                <ul className="mb-0 small">
                                                    <li>Email notification to registered users</li>
                                                    <li>In-app notifications</li>
                                                    <li>Updated date at the top of this page</li>
                                                    <li>Prominent notice on our website</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 10: Contact Information */}
                        <div className="card shadow-sm border-0" id="section-10">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <span className="badge bg-primary fs-6 me-3">10</span>
                                    <h2 className="h4 fw-bold mb-0">Contact Information</h2>
                                </div>
                                <div className="ps-5">
                                    <p>If you have any questions about these Terms, please contact us:</p>
                                    
                                    <div className="row mt-4">
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100 text-center">
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <i className="bi bi-envelope-fill text-primary fs-2"></i>
                                                    </div>
                                                    <h5 className="card-title">Email</h5>
                                                    <a href="mailto:legal@pqhub.com" className="card-text">
                                                        legal@pqhub.com
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100 text-center">
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <i className="bi bi-geo-alt-fill text-primary fs-2"></i>
                                                    </div>
                                                    <h5 className="card-title">Address</h5>
                                                    <p className="card-text">
                                                        Pegcodes Technologies<br />
                                                        Accra, Ghana
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <div className="card border h-100 text-center">
                                                <div className="card-body">
                                                    <div className="mb-3">
                                                        <i className="bi bi-clock-fill text-primary fs-2"></i>
                                                    </div>
                                                    <h5 className="card-title">Response Time</h5>
                                                    <p className="card-text">
                                                        We typically respond within<br />
                                                        3-5 business days
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="text-center mt-4">
                                        <p className="text-muted">
                                            For urgent matters, please include "URGENT" in your email subject line.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Acceptance Section */}
                        <div className="card shadow-sm border-primary mt-5">
                            <div className="card-header bg-primary text-white">
                                <h3 className="h5 mb-0">
                                    <i className="bi bi-check-circle me-2"></i>
                                    Acceptance of Terms
                                </h3>
                            </div>
                            <div className="card-body text-center">
                                <p className="mb-4">
                                    By using PQ Hub, you acknowledge that you have read, understood, and agree to be 
                                    bound by these Terms of Service.
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    <button className="btn btn-success">
                                        <i className="bi bi-check-lg me-2"></i>
                                        I Accept These Terms
                                    </button>
                                    <Link to="/" className="btn btn-outline-secondary">
                                        <i className="bi bi-x-lg me-2"></i>
                                        Decline and Exit
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Footer Navigation */}
                        <div className="text-center mt-5 pt-4 border-top">
                            <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
                                <Link to="/" className="text-decoration-none">Home</Link>
                                <Link to="/about" className="text-decoration-none">About</Link>
                                <Link to="/questions" className="text-decoration-none">Questions</Link>
                                <Link to="/contact" className="text-decoration-none">Contact</Link>
                                <Link to="/privacy" className="text-decoration-none">Privacy Policy</Link>
                            </div>
                            <p className="text-muted small">
                                © {new Date().getFullYear()} PQ Hub. All rights reserved. | 
                                Version 1.0
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </>
    );
};

export default TermsOfService;